import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import Handler from '../../Helpers/Components/Handler';
import { reloadWindowToPath } from '../../Helpers/Utils';

const Booking = (props) => {
    const { id } = useParams()
    const localizer = momentLocalizer(moment);
    const [bookingList, setBookingList] = useState([]);
    const [events, setEvents] = useState([])
    const [carDetail, setCarDetail] = useState([])
    const navigate = useNavigate()
    const eventStyleGetter = (event) => {
        return {
            style: {
                backgroundColor: event?.name === "Booked" ? "yellow" :
                    event?.name === "Ongoing" || "Started" ? "green" :
                        event?.name === "Pending" ? "red" : "",
                color: event?.name === "Booked" ? "black" : 'white',
            },
        };
    };
    const getBookingList = async () => {
        const booking = await Handler({ method: 'post', url: `/booking/available`, data: { carId: id } })
        if (booking?.success) {
            setBookingList(booking?.data)
        } else {
            setBookingList([])
        }
        const response = await Handler({ method: 'get', url: `/car/detail/${id}` })
        if (response?.success) {
            setCarDetail(response?.data)
        } else {
            reloadWindowToPath(`/car/1`)
        }
    }
    const setEvent = () => {
        setEvents(bookingList?.map((element) => {
            return {
                title: element?.bookingId,
                start: new Date(new Date(element?.deliveryDetails?.delivery).getFullYear(), new Date(element?.deliveryDetails?.delivery).getMonth(), new Date(element?.deliveryDetails?.delivery).getDate(), new Date(element?.deliveryDetails?.delivery).getHours(), new Date(element?.deliveryDetails?.delivery).getMinutes()),
                end: new Date(new Date(element?.pickupDetails?.pickup).getFullYear(), new Date(element?.pickupDetails?.pickup).getMonth(), new Date(element?.pickupDetails?.pickup).getDate(), new Date(element?.pickupDetails?.pickup).getHours(), new Date(element?.pickupDetails?.pickup).getMinutes()),
                name: element?.status
            }
        }))
    }
    useEffect(() => {
        if (bookingList?.length > 0) {
            setEvent();
        }
    }, [bookingList])
    useEffect(() => {
        getBookingList()
    }, [])
    return (
        <React.Fragment>
            <div className="arrow-back"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            <div className='mt-4 align-items-center row'>
                <div className='pt-5 col-md-3 mb-md-0 mb-3'>
                    <div className='card'>
                        <div className="text-center card-header fw-bold cardHeading text-theme">
                            Car Info
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col"> <div className="headingCard card-title"> Car ID </div> </div>
                                <div className="col"><div className="card-text">  {carDetail?.carId || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="headingCard card-title"> Model </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {carDetail?.model || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="headingCard card-title"> Reg No </div> </div>
                                <div className="col"><div className="card-text">  {carDetail?.registrationNo || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="headingCard card-title"> Color </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {carDetail?.color || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="headingCard card-title"> Fastag Bank </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {carDetail?.fasTagType || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="headingCard card-title"> Segment </div> </div>
                                <div className="col"><div className="card-text">  {carDetail?.segment || "-"} </div> </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='calendarView mb-5 col-md-9'>
                    <Calendar
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        defaultView="month"
                        eventPropGetter={eventStyleGetter}
                    />
                </div>
            </div>

        </React.Fragment>
    );
};

export default Booking;
